import React from 'react';
import PdfDeck from '../PdfDeck';

function Samalkha() {
  return <PdfDeck file='/machines-pdfs/mushroom_farm_samalkha.pdf' />;
}

export default Samalkha;
